import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import api from 'api';
import { licensesFromResponse, toLicenseUpdatePayload } from 'helpers/license';
import type { ConsultantLicenseInterface } from 'types';

export const licenseKeys = {
    all: ['licenses'] as const,
};

export const useLicenses = () =>
    useQuery({
        queryKey: licenseKeys.all,
        queryFn: async () => {
            const response = await api.licenses.get();
            return licensesFromResponse(response.data);
        },
    });

export const useUpdateLicenses = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (licenses: ConsultantLicenseInterface[]) => {
            const response = await api.licenses.put(toLicenseUpdatePayload(licenses));
            return licensesFromResponse(response.data);
        },
        onSuccess: (licenses) => {
            queryClient.setQueryData(licenseKeys.all, licenses);
        },
    });
};
